export default function state() {
	return {
		user: null,
        userList: null,
        BIKAListResponse: {
            error: true,
            message: 'Üres',
            users: [],
        },
        simpleRegistration: false,
        simpleRegistrationEmail: null,
	};
}
